import type { TensorOfferRef } from "@anaconda/core/bid/types"
import type { Nft } from "@anaconda/core/nft/types"
import { sonnerToast } from "@rarible_int/anaconda_ui_components"
import { useMolecule } from "bunshi/react"
import { useCallback, useMemo } from "react"
import { getTransactionErrorMessage } from "../events/transaction-event"
import { SolanaAcceptTensorOfferMoleculeReatom } from "./solana-accept-tensor-offer-molecule.reatom"

export function useSolanaAcceptTensorOffer() {
  const { acceptTensorOfferActionFactory } = useMolecule(
    SolanaAcceptTensorOfferMoleculeReatom,
  )
  const acceptAction = useMemo(
    () => acceptTensorOfferActionFactory(),
    [acceptTensorOfferActionFactory],
  )

  const mutate = useCallback(
    (params: { nft: Nft; offer: TensorOfferRef }) => {
      void (async () => {
        try {
          await acceptAction(params).catch(() => undefined)
        } catch (error) {
          sonnerToast.error(getTransactionErrorMessage(error))
        }
      })()
    },
    [acceptAction],
  )

  return {
    mutate,
    isPending: !!acceptAction.pending(),
  }
}
